export default __webpack_public_path__ + "static/media/doctor-icon.272d2877.svg";